import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user/line_back_ico_l.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "BACK", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "설문조사", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_SurveyList = _resolveComponent("SurveyList")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "in_back_btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, _hoisted_6),
          _hoisted_7,
          _createVNode(_component_SurveyList, {
            data: $setup.survey.data,
            surveyIdx: $setup.state.idx,
            onSubmit: $setup.surveyEntry
          }, null, 8, ["data", "surveyIdx", "onSubmit"])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.modal.content,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "yes", "no", "onClose"])
  ], 64))
}